import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import LspDeliveryProcessActions, {
  LspDeliveryProcessTypes
} from '../Stores/LspDeliveryProcess/Actions';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';

const getAppStore = state => state.app;

// eslint-disable-next-line import/prefer-default-export
export function* lspDeliveryProcessFetchLspDeliveryProcess() {
  try {
    yield put(LspDeliveryProcessActions.lspDeliveryProcessFetchLspDeliveryProcessLoading(true));

    const app = yield select(getAppStore);

    const result = [
      {
        division_id: app.curDivisionId,
        txn_flow_type: 'PURCHASE',
        proc_type: 'PUR_ORD_SYNC_01',
        step: 1,
        controller: 'purOrd',
        action: 'indexProcess',
        scan_mode: 'NULL',
        fr_res_type: 'NULL',
        to_res_type: 'PUR_ORD',
        to_doc_status: 'COMPLETE'
      },
      {
        division_id: app.curDivisionId,
        txn_flow_type: 'PURCHASE',
        proc_type: 'OUTB_ORD_02',
        step: 2,
        controller: 'outbOrd',
        action: 'indexProcess',
        scan_mode: 'NULL',
        fr_res_type: 'PUR_ORD',
        to_res_type: 'OUTB_ORD',
        to_doc_status: 'COMPLETE'
      },
      {
        division_id: app.curDivisionId,
        txn_flow_type: 'PURCHASE',
        proc_type: 'PUR_INV_SYNC_01',
        step: 3,
        controller: 'slsInv',
        action: 'indexProcess',
        scan_mode: 'NULL',
        fr_res_type: 'SLS_INV',
        to_res_type: 'NULL',
        to_doc_status: 'COMPLETE'
      },
      {
        division_id: app.curDivisionId,
        txn_flow_type: 'PURCHASE',
        proc_type: 'PUR_ORD_DIVISION_MAP',
        step: 3,
        controller: 'purOrd',
        action: 'indexProcess',
        scan_mode: 'NULL',
        fr_res_type: 'PUR_ORD',
        to_res_type: 'NULL',
        to_doc_status: 'NULL'
      }
    ];

    yield put(LspDeliveryProcessActions.lspDeliveryProcessFetchLspDeliveryProcessSuccess(result));
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(LspDeliveryProcessActions.lspDeliveryProcessFetchLspDeliveryProcessLoading(false));
  }
}

export function* lspDeliveryProcessShowSyncSetting() {
  try {
    yield put(LspDeliveryProcessActions.lspDeliveryProcessShowSyncSettingLoading(true));

    const app = yield select(getAppStore);
    const result = yield call(
      ApiService.getApi,
      app.apiUrl,
      `syncSetting/showDivisionSetting/PUR_ORD_SYNC_01/${app.curDivisionId}`,
      app.token,
      'multipart/form-data'
    );

    if (result.isSuccess === true) {
      yield put(LspDeliveryProcessActions.lspDeliveryProcessShowSyncSettingSuccess(result.data));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(LspDeliveryProcessActions.lspDeliveryProcessShowSyncSettingLoading(false));
  }
}

export const saga = [
  takeLatest(
    LspDeliveryProcessTypes.LSP_DELIVERY_PROCESS_FETCH_LSP_DELIVERY_PROCESS,
    lspDeliveryProcessFetchLspDeliveryProcess
  ),
  takeLatest(
    LspDeliveryProcessTypes.LSP_DELIVERY_PROCESS_SHOW_SYNC_SETTING,
    lspDeliveryProcessShowSyncSetting
  )
];
